import React from 'react';
import moment from 'moment';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import { shortenStringWithTooltip, toShowArrayToString } from '../../helper';

function OprationalCPCard({
  item,
  index,
  selectedIds,
  isArchived,
  isSupplierLoggedIn,
  onCheck,
  handleEdit,
  handlePin,
  deleteCard,
  activeInActiveCard,
  handleExpand,
  archiveCard,
  handleDuplicate,
  OperationalAddEditAccess,
  OperationalDeleteAccess,
  subBrandAccess,
}) {
  const dateFormat = 'DD-MMMM-YYYY, h:mm a';
  const { t } = useTranslation('common');

  const showCreatedandModified = (ele) => {
    return (
      <button type="button" className="btn btn-action-icon" style={{ margin: '0' }}>
        <div className="info-container xs-position-bottom iconfirst testing-action-spaceremoval">
          <i className="icon-info f-16" />
          <div className="info-content text-nowrap">
            {ele?.createdBy?.firstName && (
              <p className="text-left m-0">
                <strong>{t('OPRATIONAL_CP_CARD.CREATED')}</strong> : {`${ele?.createdBy?.firstName} ${ele?.createdBy?.lastName} | `}
                {moment(ele?.createdAt).format(dateFormat)}
              </p>
            )}
            {ele?.modifiedBy?.firstName && (
              <p className="text-left m-0">
                <strong>{t('OPRATIONAL_CP_CARD.MODIFIED')}</strong> : {`${ele?.modifiedBy?.firstName} ${ele?.modifiedBy?.lastName} | `}
                {moment(ele?.updatedAt).format(dateFormat)}
              </p>
            )}
          </div>
        </div>
      </button>
    );
  };

  const showComment = (ele) => {
    return (
      <button type="button" className="btn btn-action-icon " style={{ margin: '0', padding: '0 2px !important' }}>
        <div className="custom-popover-container testing-action-spaceremoval">
          <button type="button">
            <i className="icon-chat-bubble f-16" />
          </button>
          <div className="custom-popover-content">
            <span className="arrow" />
            {ele?.archivedBy?.firstName && (
              <p className="text-left m-0">
                {`${ele?.archivedBy?.firstName} ${ele.archivedBy?.lastName} | `}
                {ele?.archivedAt ? moment(ele?.archivedAt).format(dateFormat) : null}
              </p>
            )}
            {ele?.archiveComment && !isEmpty(ele?.archiveComment) && (
              <div className="comment">
                <p className="m-0">{ele?.archiveComment}</p>
              </div>
            )}
          </div>
        </div>
      </button>
    );
  };

  return (
    <div className="listing-card card mt-2 mt-md-5">
      <div className="card-header">
        {!isSupplierLoggedIn && (
          <div className="d-flex">
            <ul className="card-header-icon ">
              {(OperationalDeleteAccess || OperationalAddEditAccess) && (
                <li className="xs-order-zero">
                  <div className="cus-chk-block">
                    <input
                      onChange={(e) => {
                        onCheck(e, item?._id);
                      }}
                      name={`check_${index}`}
                      id={`check_${index}`}
                      type="checkbox"
                      checked={selectedIds?.includes(item?._id)}
                    />
                    <label htmlFor={`check_${index}`} className="cus-chklabel" />
                  </div>
                </li>
              )}
              {!item?.isArchived && OperationalAddEditAccess && (
                <>
                  <li className="li-padding-remove">
                    <button type="button" className="btn btn-action-icon" title={t('OPRATIONAL_CP_CARD.DUPLICATE')} onClick={() => handleDuplicate(item)}>
                      <span className="icon-copy" />
                    </button>
                  </li>
                  <li className="li-padding-remove">
                    <button
                      type="button"
                      onClick={() => handleEdit(item?._id)}
                      className="btn btn-action-icon"
                      title={t('OPRATIONAL_CP_CARD.EDIT')}
                      disabled={isArchived}
                    >
                      <i className="icon-edit" />
                    </button>
                  </li>
                </>
              )}
              {OperationalAddEditAccess && (
                <li className="li-padding-remove">
                  <button
                    type="button"
                    onClick={() => archiveCard(item?._id)}
                    title={isArchived ? t('OPRATIONAL_CP_CARD.UNARCHIVE') : t('OPRATIONAL_CP_CARD.ARCHIVE')}
                    className="btn btn-action-icon"
                  >
                    <i className="icon-server" />
                  </button>
                </li>
              )}
              {item?.isArchived && <li>{showComment(item)}</li>}
              {!item?.isArchived && OperationalAddEditAccess && (
                <li className="li-padding-remove">
                  <button
                    type="button"
                    title={item.isActive ? t('OPRATIONAL_CP_CARD.ACTIVE') : t('OPRATIONAL_CP_CARD.INACTIVE')}
                    className="btn btn-action-icon"
                    onClick={() => activeInActiveCard(item, index)}
                  >
                    <i className={item?.isActive ? 'icon-active' : 'icon-inactive'} />
                  </button>
                </li>
              )}
              {OperationalDeleteAccess && isArchived && (
                <li className="li-padding-remove">
                  <button type="button" title={t('OPRATIONAL_CP_CARD.DELETE')} className="btn btn-action-icon" onClick={() => deleteCard(item?._id)}>
                    <i className="icon-delete" />
                  </button>
                </li>
              )}
              <li className="xs-order-one  p-0">{showCreatedandModified(item)}</li>
            </ul>
            <div className="ml-auto">
              <ul className="card-header-icon">
                {OperationalAddEditAccess && (
                  <li className="li-padding-remove">
                    <button
                      type="button"
                      onClick={() => handlePin(item)}
                      className="btn btn-action-icon"
                      title={t('OPRATIONAL_CP_CARD.PIN')}
                      disabled={!OperationalAddEditAccess}
                    >
                      <i className={`icon-marker-pin-save ${item?.pinned && 'pin-active'}`} />
                    </button>
                  </li>
                )}
              </ul>
            </div>
          </div>
        )}
      </div>
      <div className="card-body">
        <h4 className="title link-title" onClick={() => handleExpand(item)}>
          {shortenStringWithTooltip(item?.name, 30)}
          <i className="icon-detail_page pl-1" />
        </h4>
        <ul className="card-ul">
          <li>
            <strong>{t('OPRATIONAL_CP_CARD.BRAND')} </strong>
            {toShowArrayToString(item, 'brand', 40)}
          </li>
          {subBrandAccess && (
            <li>
              <strong>{t('OPRATIONAL_CP_CARD.SUBBRAND')} </strong>
              {toShowArrayToString(item, 'subBrand', 40)}
            </li>
          )}
          <li className="text-truncate">
            <strong>{t('OPRATIONAL_CP_CARD.SEASON')} </strong>
            {toShowArrayToString(item, 'season', 40)}
          </li>
          <li>
            <strong>{t('OPRATIONAL_CP_CARD.PRODUCT_TYPE')} </strong>
            {toShowArrayToString(item, 'productType', 40)}
          </li>
          <li>
            <strong>{t('OPRATIONAL_CP_CARD.CATEGORY_1')} </strong>
            {toShowArrayToString(item, 'catOneId', 40)}
          </li>
          <li>
            <strong>{t('OPRATIONAL_CP_CARD.CATEGORY_2')} </strong>
            {toShowArrayToString(item, 'catTwoId', 40)}
          </li>
          <li>
            <strong>{t('OPRATIONAL_CP_CARD.CATEGORY_3')} </strong>
            {toShowArrayToString(item, 'catThreeId', 40)}
          </li>
          <li>
            <strong>{t('OPRATIONAL_CP_CARD.CATEGORY_4')} </strong>
            {toShowArrayToString(item, 'catFourId', 40)}
          </li>

          <li>
            <strong>{t('OPRATIONAL_CP_CARD.SUPPLIER')} </strong>
            {toShowArrayToString(item, 'suppliers', 40)}
          </li>
        </ul>
      </div>
    </div>
  );
}

export default OprationalCPCard;
